import { createAction } from '/@/store/utils';

export const updateActiveRecommendation = createAction('ACTIVE_RECOMMENDATION:UPDATE');

export const updateActiveRecommendationCropConfig = createAction('ACTIVE_RECOMMENDATION:UPDATE_CROP_CONFIG');
